import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CheckCircleFilled, CheckCircleOutlined, InfoCircleFilled } from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import { observer } from "mobx-react";
import { IN_APP_FOMO_URL_PARAMETER_TO_DEACTIVATE_WEBSITE_FOMO, UPSELL_TAG_BACKGROUND_COLOR, UpsellInAppFomoCouponCounter } from "@devowl-wp/react-cookie-banner-admin";
import { useScannerProgress } from "../../../hooks/useScannerProgress.js";
import { useStores } from "../../../store/stores.js";
import { __ } from "../../../utils/i18n.js";
const DashboardChecklistItem = observer(({ id, checked, title, description, link, linkText, linkTarget, needsPro, onLinkClick })=>{
    const { optionStore: { others: { isPro }, fomoCoupon } } = useStores();
    const isInfo = !isPro && needsPro;
    let extraContentTag = null;
    let extraContentDescription = null;
    let useLink = link;
    switch(id){
        case "scanner":
            {
                const { percent: scanPercent, remaining: scanRemaining, currentJob } = useScannerProgress();
                if (scanRemaining > 0 && scanPercent > 0 && currentJob?.group_position > 0) {
                    extraContentTag = /*#__PURE__*/ _jsx(Tag, {
                        children: __("Currently scanning (%d %%)", scanPercent)
                    });
                }
                break;
            }
        case "get-pro":
            {
                extraContentDescription = /*#__PURE__*/ _jsx(UpsellInAppFomoCouponCounter, {});
                if (fomoCoupon) {
                    useLink += `&${IN_APP_FOMO_URL_PARAMETER_TO_DEACTIVATE_WEBSITE_FOMO}`;
                }
                break;
            }
        default:
            break;
    }
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            margin: "5px 0"
        },
        children: [
            /*#__PURE__*/ _jsx(Tooltip, {
                title: checked && description,
                children: /*#__PURE__*/ _jsxs("span", {
                    children: [
                        isInfo ? /*#__PURE__*/ _jsx(InfoCircleFilled, {
                            style: {
                                color: "#7ec8ec"
                            }
                        }) : checked ? /*#__PURE__*/ _jsx(CheckCircleFilled, {
                            style: {
                                color: "#52c41a"
                            }
                        }) : /*#__PURE__*/ _jsx(CheckCircleOutlined, {
                            style: {
                                color: "#e2e2e2"
                            }
                        }),
                        " ",
                        /*#__PURE__*/ _jsx("span", {
                            style: {
                                textDecoration: checked ? "line-through" : undefined,
                                fontWeight: "bold"
                            },
                            children: title
                        }),
                        !!useLink && !!linkText && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                "\xa0\xa0•\xa0\xa0",
                                /*#__PURE__*/ _jsx("a", {
                                    href: useLink,
                                    target: linkTarget,
                                    rel: "noreferrer",
                                    onClick: onLinkClick,
                                    children: linkText
                                })
                            ]
                        })
                    ]
                })
            }),
            isInfo && id !== "get-pro" && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    "\xa0",
                    /*#__PURE__*/ _jsx(Tag, {
                        color: UPSELL_TAG_BACKGROUND_COLOR,
                        children: __("Needs PRO")
                    })
                ]
            }),
            !!extraContentTag && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    "\xa0",
                    extraContentTag
                ]
            }),
            !!description && !checked && /*#__PURE__*/ _jsx("p", {
                className: "description",
                style: {
                    paddingLeft: 17
                },
                children: description
            }),
            !!extraContentDescription && /*#__PURE__*/ _jsx("div", {
                style: {
                    paddingLeft: 17
                },
                children: extraContentDescription
            })
        ]
    });
});
export { DashboardChecklistItem };
